// extracted by mini-css-extract-plugin
module.exports = {"brand":"topbar-brand_brand__IV1h9","brandSymbol":"topbar-brand_brandSymbol__qkWfR"};